import app from "flarum/common/app";
import FormModal from "flarum/common/components/FormModal";
import Button from "flarum/common/components/Button";
import { gradients, request, single, t } from "../api";
export default class FactEditor extends FormModal {
  text = "";
  background = "violet";
  kept = [];
  files = [];
  error = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.text = this.attrs.story?.content ?? "";
    this.background = this.attrs.story?.background ?? "violet";
    this.kept = [...(this.attrs.story?.images ?? [])];
  }
  className() {
    return "FactEditor Modal--large";
  }
  title() {
    return t(this.attrs.story ? "edit" : "create");
  }
  onremove(vnode) {
    this.files.forEach(f => URL.revokeObjectURL(f.url));
    super.onremove(vnode);
  }
  content() {
    return m("div", {
      className: "Modal-body FactEditor-body"
    }, m("p", null, t("editor_help")), this.error && m("p", {
      role: "alert"
    }, t("image_error")), m("label", null, t("content"), m("textarea", {
      className: "FormControl",
      maxlength: 2000,
      rows: 5,
      value: this.text,
      disabled: this.loading,
      oninput: e => this.text = e.target.value
    })), m("label", null, t("background"), m("select", {
      className: "FormControl",
      value: this.background,
      disabled: this.loading,
      onchange: e => this.background = e.target.value
    }, gradients.map(g => m("option", {
      value: g
    }, t(g))))), m("div", {
      className: "FactEditor-preview Fact-gradient--" + this.background
    }, this.text || t("preview")), m("label", null, t("images"), m("input", {
      type: "file",
      accept: "image/jpeg,image/png,image/webp",
      multiple: true,
      disabled: this.loading,
      onchange: e => {
        const input = e.target;
        const files = Array.from(input.files ?? []);
        this.error = this.kept.length + this.files.length + files.length > 5 || files.some(f => f.size > 5 * 1024 * 1024 || !["image/jpeg", "image/png", "image/webp"].includes(f.type));
        if (!this.error) this.files.push(...files.map(file => ({
          file,
          url: URL.createObjectURL(file)
        })));
        input.value = "";
      }
    })), m("div", {
      className: "FactEditor-images"
    }, this.kept.map(image => m("div", null, m("img", {
      src: image.url,
      alt: ""
    }), m(Button, {
      disabled: this.loading,
      onclick: () => this.kept = this.kept.filter(i => i.path !== image.path)
    }, t("remove_image")))), this.files.map(image => m("div", null, m("img", {
      src: image.url,
      alt: ""
    }), m(Button, {
      disabled: this.loading,
      onclick: () => {
        URL.revokeObjectURL(image.url);
        this.files = this.files.filter(i => i !== image);
      }
    }, t("remove_image"))))), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading,
      disabled: !this.text.trim() && !this.kept.length && !this.files.length
    }, t("submit")));
  }
  async onsubmit(event) {
    event.preventDefault();
    if (this.loading) return;
    this.loading = true;
    const body = new FormData();
    body.append("content", this.text);
    body.append("background", this.background);
    body.append("keepImages", JSON.stringify(this.kept.map(i => i.path)));
    if (this.attrs.story) body.append("revision", String(this.attrs.story.revision));
    this.files.forEach(f => body.append("images[]", f.file));
    try {
      const story = single(await request(this.attrs.story ? "/" + this.attrs.story.id : "", "POST", body));
      this.attrs.onsaved(story);
      app.modal.close();
    } catch {
      /* Flarum displays API validation errors. */
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('xgay-fact', 'common/components/FactEditor', FactEditor);